import React from 'react';
import { useIntl } from 'react-intl';
import CategoryCard, { Category } from './components/CategoryCard';
import SubCategoryCard from './components/SubCategoryCard';
import { useNavigate } from 'react-router-dom';
import RedirectionModal from './../../common/components/modal/RedirectionModal';
import { useRedirectionModal } from './../../common/components/modal/hooks/useRedirectionModal';

interface HebergementProps {
  categoryId?: string;
}

const Hebergement: React.FC<HebergementProps> = ({ categoryId }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { isOpen, closeModal, confirmRedirection, handleContinue, pendingUrl } = useRedirectionModal();

  const categories: Category[] = [
    {
      id: 1,
      icon: 'fa-solid fa-server',
      title: intl.formatMessage({id: 'MARKETPLACE.HOSTING.SHARED.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.HOSTING.SHARED.DESC'}),
      iconBg: 'primary',
      urlCommande: '', // Vide = a des sous-catégories
      urlEnSavoirPlus: 'https://www.nuxit.com/hebergement-web-mutualise/',
      isActive: true,
      subCategories: [
        {
          id: 11,
          icon: 'fa-solid fa-star',
          title: 'Nuxit Web 1',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SITES_1'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_50'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SQL_2_250'})}</span>
            </div>
          ),
          tarif: '3.15€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/hebergement-web/12873',
          urlEnSavoirPlus: '',
          isActive: true,
        },
        {
          id: 12,
          icon: 'fa-solid fa-rocket',
          title: 'Nuxit Web 2',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SITES_3'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_100'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SQL_6_500'})}</span>
            </div>
          ),
          tarif: '5.25€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/hebergement-web/12870',
          urlEnSavoirPlus: '',
          isActive: true,
        },
        {
          id: 13,
          icon: 'fa-solid fa-rocket',
          title: 'Nuxit Web 3',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SITES_8'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_250'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SQL_12_1G'})}</span>
            </div>
          ),
          tarif: '8.40€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/hebergement-web/12871',
          urlEnSavoirPlus: '',
          isActive: true,
        },
      ],
    },
    {
      id: 2,
      icon: 'fa-solid fa-bolt',
      title: intl.formatMessage({id: 'MARKETPLACE.HOSTING.PERF.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.HOSTING.PERF.DESC'}),
      iconBg: 'primary',
      urlCommande: '',
      urlEnSavoirPlus: 'https://www.nuxit.com/hebergement-web-performance/',
      isActive: true,
      subCategories: [
        {
          id: 14,
          icon: 'fa-solid fa-star',
          title: 'Performance 4G',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.CORES_2'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.RAM_4'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_75'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SITES_3'})}</span>
            </div>
          ),
          tarif: '8.40€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/hebergement-web/12872',
          urlEnSavoirPlus: '',
          isActive: true,
        },
        {
          id: 15,
          icon: 'fa-solid fa-rocket',
          title: 'Performance 10G',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.CORES_6'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.RAM_10'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_150'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SITES_5'})}</span>
            </div>
          ),
          tarif: '15.75€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/hebergement-web/12874',
          urlEnSavoirPlus: '',
          isActive: true,
        },
        {
          id: 16,
          icon: 'fa-solid fa-rocket',
          title: 'Performance 20G',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.CORES_10'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.RAM_20'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_250'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SITES_10'})}</span>
            </div>
          ),
          tarif: '26€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/hebergement-web/12875',
          urlEnSavoirPlus: '',
          isActive: true,
        },
        {
          id: 17,
          icon: 'fa-solid fa-rocket',
          title: 'Performance 40G',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.CORES_16'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.RAM_40'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_400'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SITES_20'})}</span>
            </div>
          ),
          tarif: '47€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/hebergement-web/12876',
          urlEnSavoirPlus: '',
          isActive: true,
        },
      ],
    },
    {
      id: 3,
      icon: 'fa-solid fa-building',
      title: intl.formatMessage({id: 'MARKETPLACE.HOSTING.DEDICATED.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.HOSTING.DEDICATED.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://www.nuxit.com/serveur-dedie/',
      urlEnSavoirPlus: 'https://www.nuxit.com/serveur-dedie/',
      isActive: true,
    },
    {
      id: 5,
      icon: 'fa-solid fa-cloud',
      title: intl.formatMessage({id: 'MARKETPLACE.HOSTING.VPS.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.HOSTING.VPS.DESC'}),
      iconBg: 'primary',
      urlCommande: '',
      urlEnSavoirPlus: 'https://www.nuxit.com/vps/',
      isActive: true,
      subCategories: [
        {
          id: 18,
          icon: 'fa-solid fa-cloud',
          title: 'VPS 2G',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.CORES_2'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.RAM_2'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_50'})}</span>
            </div>
          ),
          tarif: '8.00€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/vps/12719',
          urlEnSavoirPlus: '',
          isActive: true,
        },
        {
          id: 19,
          icon: 'fa-solid fa-cloud',
          title: 'VPS 4G',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.CORES_4'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.RAM_4'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_100'})}</span>
            </div>
          ),
          tarif: '15€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/vps/12720',
          urlEnSavoirPlus: '',
          isActive: true,
        },
        {
          id: 20,
          icon: 'fa-solid fa-cloud',
          title: 'VPS 8G',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.CORES_8'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.RAM_8'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_200'})}</span>
            </div>
          ),
          tarif: '28€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/vps/12721',
          urlEnSavoirPlus: '',
          isActive: true,
        },
        {
          id: 21,
          icon: 'fa-solid fa-cloud',
          title: 'VPS 16G',
          description: (
            <div className="text-center mb-0 text-start py-2">
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.CORES_16'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.RAM_16'})}</span><br/>
              <span>{intl.formatMessage({id: 'MARKETPLACE.HOSTING.SSD_400'})}</span>
            </div>
          ),
          tarif: '50€ HT/mois',
          iconBg: 'primary',
          urlCommande: 'https://store.nuxit.com/vps/12722',
          urlEnSavoirPlus: '',
          isActive: true,
        },
      ],
    },
    {
      id: 6,
      icon: 'fa-brands fa-wordpress',
      title: intl.formatMessage({id: 'MARKETPLACE.HOSTING.WORDPRESS.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.HOSTING.WORDPRESS.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://www.wpserveur.net/tarifs-hebergement-wordpress/',
      urlEnSavoirPlus: 'https://www.wpserveur.net/',
      isActive: true,
    },
    {
      id: 7,
      icon: 'fa-solid fa-globe',
      title: intl.formatMessage({id: 'MARKETPLACE.HOSTING.DOMAIN.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.HOSTING.DOMAIN.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://www.nuxit.com/creation-et-transfert-de-domaine/',
      urlEnSavoirPlus: 'https://www.nuxit.com/creation-et-transfert-de-domaine/',
      isActive: true,
    },
    {
      id: 8,
      icon: 'fa-brands fa-microsoft',
      title: intl.formatMessage({id: 'MARKETPLACE.HOSTING.M365.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.HOSTING.M365.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://www.nuxit.com/microsoft-365/',
      urlEnSavoirPlus: 'https://www.nuxit.com/microsoft-365/',
      isActive: true,
    },
    {
      id: 9,
      icon: 'fa-solid fa-cloud-arrow-up',
      title: intl.formatMessage({id: 'MARKETPLACE.HOSTING.BACKUP.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.HOSTING.BACKUP.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://www.nuxit.com/drivin-cloud/',
      urlEnSavoirPlus: 'https://www.nuxit.com/drivin-cloud/',
      isActive: true,
    },
  ];

  const selectedCategory = categoryId
    ? categories.find(cat => cat.id === parseInt(categoryId))
    : null;

  const handleOrder = (categoryTitle: string) => {
    const category = categories.find(cat => cat.title === categoryTitle);

    if (category?.subCategories && category.subCategories.length > 0) {
      navigate(`/marketplace/hebergement/${category.id}`);
    } else if (category?.urlCommande) {
      confirmRedirection(category.urlCommande);
    }
  };

  const handleLearnMore = (categoryTitle: string) => {
    const category = categories.find(cat => cat.title === categoryTitle);
    if (category?.urlEnSavoirPlus) {
      confirmRedirection(category.urlEnSavoirPlus);
    }
  };

  const handleBack = () => {
    navigate('/marketplace/hebergement');
  };

  const handleSubCategoryOrder = (url: string) => {
    confirmRedirection(url);
  };

  const handleSubCategoryLearnMore = (url?: string) => {
    if (url) {
      confirmRedirection(url);
    }
  };

  // Affichage des sous-catégories
  if (selectedCategory?.subCategories) {
    return (
      <>
        <RedirectionModal
          show={isOpen}
          onCancel={closeModal}
          onContinue={handleContinue}
          url={pendingUrl || ''}
        />

        <div>
          <div className="d-flex align-items-center mb-4 gap-3">
            <button
              className="btn btn-outline-primary d-flex align-items-center justify-content-center"
              onClick={handleBack}
              style={{
                width: '40px',
                height: '40px',
                padding: '0'
              }}
            >
              <i className="fa-solid fa-arrow-left"></i>
            </button>
            <h2 className="mb-0">{selectedCategory.title}</h2>
          </div>

          <p className="text-muted mb-4">{selectedCategory.description}</p>

          <div className="row g-4">
            {selectedCategory.subCategories.map((subCategory) => (
              <SubCategoryCard
                key={subCategory.id}
                subCategory={subCategory}
                onOrder={handleSubCategoryOrder}
                onLearnMore={handleSubCategoryLearnMore}
              />
            ))}
          </div>
        </div>
      </>
    );
  }


  // Affichage des catégories principales
  return (
    <>
      <RedirectionModal
        show={isOpen}
        onCancel={closeModal}
        onContinue={handleContinue}
        url={pendingUrl || ''}
      />

      <div className="row g-4">
        {categories.map((category) => (
          <CategoryCard
            key={category.id}
            category={category}
            onOrder={handleOrder}
            onLearnMore={handleLearnMore}
          />
        ))}
      </div>
    </>
  );
};

export default Hebergement;
